import { SubTask } from '@app/domain';
import { SubTaskDTO } from '../dtos/sub-task.dto';

// Maps between the API DTO and the Domain Entity
export class SubTaskMapper {
  subTaskToDomain(dto: SubTaskDTO): SubTask {
    return {
      id: dto.id,
      taskTemplateId: dto.taskTemplateId,
      subTaskName: dto.subTaskName,
      subTaskDescription: dto.subTaskDescription,
      subTaskIndex: dto.subTaskIndex,
      isIncludeAttachmentsField: dto.isIncludeAttachmentsField,
      isAttachmentsFieldOptional: dto.isAttachmentsFieldOptional,
      isIncludeRemarksField: dto.isIncludeAttachmentsField,
      isRemarksFieldOptional: dto.isRemarksFieldOptional,
      elements: dto.elements,
      dataSources: dto.dataSources,
      summaryData: dto.summaryData
        ? {
            totalInputFields: dto.summaryData.totalInputFields,
          }
        : null,
      isActive: dto.isActive,
    };
  }

  subTasksListToDomain(dtos: SubTaskDTO[]): SubTask[] {
    return dtos.map(dto => this.subTaskToDomain(dto));
  }
}
